// routes
import Router from 'routes';
// theme
import ThemeProvider from 'theme';
// components
import ScrollToTop from 'components/ScrollToTop';
import { ProgressBarStyle } from 'components/ProgressBar';
import NotistackProvider from 'components/NotistackProvider';
import ThemeColorPresets from 'components/ThemeColorPresets';
import MotionLazyContainer from 'components/animate/MotionLazyContainer';
import IdleTimeOutHandler from 'components/IdleTimeOutHandler';
import LoaderCallApi from 'components/LoaderCallApi';
import ThemeLocalization from 'components/ThemeLocalization';

import { AxiosInterceptor,setAxiosBaseURL } from 'utils/axios';

import useConfig from 'hooks/useConfig';

// ----------------------------------------------------------------------
export default function App() {

  const config = useConfig();

  if (!config) {
    // While config is being loaded
    return <div/>;
  }

  setAxiosBaseURL(config.REACT_APP_API_URL);
  return (
    <ThemeProvider>
      <ThemeColorPresets>
        <ThemeLocalization>
          <NotistackProvider>
            <MotionLazyContainer>
              <ProgressBarStyle />
              <ScrollToTop />
              <IdleTimeOutHandler />
              <LoaderCallApi />
              <AxiosInterceptor />
              <Router />
            </MotionLazyContainer>
          </NotistackProvider>
        </ThemeLocalization>
      </ThemeColorPresets>
    </ThemeProvider>
  );
}
